import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { SenhasService } from "src/app/services/senhas.service";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-esqueceu-senha',
  templateUrl: './esqueceu-senha.component.html',
  styleUrls: ['./esqueceu-senha.component.scss']
})
export class EsqueceuSenhaComponent implements OnInit, OnDestroy {
  emailForm: UntypedFormGroup;
  enviado: boolean;
  selector: string;
  newSubs: Subscription;

  constructor(
    private activeModal: NgbActiveModal,
    private _fb: UntypedFormBuilder,
    private translate: TranslateService,
    private senhasService: SenhasService,
    private toastr: ToastrService,
    private elemRef: ElementRef,
) {
    this.selector = elemRef.nativeElement.tagName.toLowerCase();
}

  ngOnInit(): void {
    document.getElementsByTagName(this.selector)[0]['style']['zoom'] = '0.85'
    this.buildForm()
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
  }

  close(result?) {
    this.activeModal.close(result);
  }

  buildForm() {
    this.emailForm = this._fb.group({
      email: ["", Validators.required],
    },{ validators: this.emailValidator });
  }

  onSubmit(){
    let email = this.emailForm.get('email').value;
    this.newSubs = this.senhasService.sendRecoveryEmail(email).subscribe(
      result => {
        if(result.status_code === 200){
          this.enviado = true
        } else {
          this.toastr.show(this.translate.instant('ALGO_DEU_ERRADO'), "", environment.toastrConfig("danger"));
        }
      }
    )
  }

  emailValidator(group: UntypedFormGroup) {
    let email = group.get('email').value;
    let pattern = new RegExp(
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/
    );
    if(email.match(pattern)){
      return null
    } else{
      //swal.fire(this.translate.instant('EMAIL_INVALIDO'),'','error');
      //this.toastr.show(this.translate.instant('EMAIL_INVALIDO'), "", environment.toastrConfig("danger"));
      return { notSame: true }
    }
  }

  verificaRequerido(campo): boolean {
    let email = this.emailForm.get(campo).value
    let pattern = new RegExp(
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/
    );
    if(email.match(pattern)){
      return false
    } else{
      //swal.fire(this.translate.instant('EMAIL_INVALIDO'),'','error');
      //this.toastr.show(this.translate.instant('EMAIL_INVALIDO'), "", environment.toastrConfig("danger"));
      return true
    }
  }

}
